/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { DocumentWorkflowStep } from '../models/document-workflow-step';
export interface DocumentWorkflow {
  steps?: Array<DocumentWorkflowStep> | null;
}

export class DocumentWorkflow {
  steps?: DocumentWorkflowStep[] | null;

  constructor(value: DocumentWorkflow) {
    this.steps = value?.steps?.map((x) => new DocumentWorkflowStep(x));
  }
}
